import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, } from "react";
/**
 * The context permits to have one checkbox dropdown open at a time.
 */
const TaskCheckboxContext = createContext(undefined);
export const useTaskCheckboxContext = () => useContext(TaskCheckboxContext);
export const TaskCheckboxContextProvider = ({ children }) => {
    const [openedCheckboxElement, setOpenedCheckboxElement] = useState(undefined);
    const setCheckboxClosed = () => {
        setOpenedCheckboxElement(undefined);
    };
    return (_jsx(TaskCheckboxContext.Provider, { value: {
            openedCheckboxElement,
            setOpenedCheckboxElement,
            setCheckboxClosed,
        }, children: children }));
};
